/**
 * @author xiaohuangmaoth
 * @date 2020-09-08
 * @desc 内容查看
 */
import React from "react";
import { connect } from "dva";
import { Descriptions } from "antd";
import {framework_tool, component_tool, utils_tool} from "@/tool";
import columns from "./columns";
import "./index.less";

const { WizContainer, modelUtils, ossFileUtils } = framework_tool;
const { WizSpin, WizCard, WizEmpty, WizInput, WizRow, WizCol } = component_tool;
const { TextArea } = WizInput;
const {Session} = utils_tool
const {getOssImgResizeUrl} = ossFileUtils

import {getDetailRecord} from '@/containers/content/util'

class ContentView extends WizContainer {
  componentName = "ContentView";

  constructor(props) {
    super(props);
    this.state = {
      record: {},
    };
    this.detailInfo = getDetailRecord(props.history);
  }

  _componentDidMount() {
    this.doAction({
      path: "contentManage/detailInfo",
      payload: {
        key: "detailInfo",
        apiParams: { id: this.detailInfo.id },
      },
    });
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    detailInfo: this._detailInfo.bind(this),
  };

  _detailInfo(nextProps, nextState) {
    const { detailInfo } = nextProps;
    if (detailInfo["success"] && detailInfo["data"]) {
      let contentTextList = detailInfo["data"]['contentTextList']
      if (contentTextList && contentTextList.length) {
        contentTextList = contentTextList.sort((a, b) => { return a.id - b.id })
      }
      nextState.record = { ...this.detailInfo, ...detailInfo.data, contentTextList };
      return true;
    } else {
      wizNotice.error(detailInfo['msg'] || "获取数据失败请稍后在试")
    }
    return false;
  }

  getContentListByContentType = (contentType, contentTextList, hiddenType = 0) => {
    switch (contentType) {
      case 1:
        return (
          <div className="content-view-img"
            dangerouslySetInnerHTML={{
              __html:
                contentTextList.length && contentTextList[0].contentDetail,
            }}
          ></div>
        );
      case 2:
        return <Images data={contentTextList}/>;
      case 3:
      case 4:
      case 5:
        return <Video data={contentTextList} />;
      default:
        return <WizEmpty />;
    }
  };

  _render() {
    const { contentManageLoading } = this.props;
    const { record } = this.state;
    return (
      <WizSpin spinning={contentManageLoading}>
        <WizCard title="基础信息">
          <Descriptions column={1} bordered={true}>
            {columns(record).map((val, index) => (
              <Descriptions.Item key={index} label={val.label}>
                {val.value}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </WizCard>
        <WizCard title="详细内容">
          {this.getContentListByContentType(
            record.contentType,
            record.contentTextList,
            record.hiddenType,
          )}
        </WizCard>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { contentManage } = state;
  const detailInfo = modelUtils.getModelEntity(contentManage, "detailInfo");
  const load = modelUtils.getLoadingState(state, "contentManage");
  return {
    detailInfo,
    ...load,
  };
};

export default connect(mapStateToProps)(ContentView);

function Images({ data }) {

  return (
    <WizRow className="images-view-wrp" gutter={[12, 12]}>
      {data && data.length ? (
        data.map((val, index) => (
          <WizCol key={index.toString()} xs={24} sm={12} md={8} lg={6}>
            <WizRow type="flex" gutter={2} className="image-item">
              <WizCol span={14} className="image-item-imgbox">
                <img
                  className="image-item-img"
                  src={getOssImgResizeUrl(val.fileUri, {
                    m: "lfit",
                    w: 300,
                    h: 200,
                  }, true)}
                  alt=""
                />
              </WizCol>
              <WizCol span={10} className="image-item-desc">
                <TextArea
                  // placeholder="请输入描述..."
                  style={{ height: '100%' }}
                  value={val.contentDetail}
                  readOnly
                ></TextArea>
              </WizCol>
            </WizRow>
          </WizCol>
        ))
      ) : (
          <WizEmpty />
        )}
    </WizRow>
  );
}

function Video({ data }) {
  return data && data.length ? (
    <Descriptions column={1}>
      {data.map((val, index) => (
        <Descriptions.Item key={index} label={`文件${index + 1}`}>
          {val.fileName} <span style={{ marginLeft: 10 }}>({(val.fileSize / 1024).toFixed(1)}KB)</span>
        </Descriptions.Item>
      ))}
    </Descriptions>
  ) : (
      <WizEmpty />
    );
}
